import * as React from 'react'

// Hand-rolled `**bold**` splitter — NOT a markdown parser. It never touches
// innerHTML; every segment (including attacker-influenceable scraped values
// like industry/niche/host) is emitted as a plain React text node, just
// optionally wrapped in <strong>. This is intentional: copy functions in
// useOnboardingMachine.ts are the only source of the `**` markers, so this
// never interprets user-controlled `**` sequences as anything but literal
// characters split points — the wrapped text itself is still plain text.
export function renderBoldSegments(text: string): React.ReactNode {
  const parts = text.split(/(\*\*[^*]*\*\*)/g)
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length >= 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>
    }
    return <React.Fragment key={i}>{part}</React.Fragment>
  })
}
